const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": "https://gurukrupawood.com/#website",

  "url": "https://gurukrupawood.com/",

  "name": "Gurukrupa Wood Pvt. Ltd.",

  "description":
    "Official website of Gurukrupa Wood Pvt. Ltd., manufacturer of wooden pallets, boxes, crates and export packaging solutions.",

  "publisher": {
    "@id": "https://gurukrupawood.com/#organization"
  }
};

export default websiteSchema;